import { render, staticRenderFns } from "./CoozzyFaxIcon.vue?vue&type=template&id=da96a1c0&scoped=true"
import script from "./CoozzyFaxIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFaxIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFaxIcon.vue?vue&type=style&index=0&id=da96a1c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da96a1c0",
  null
  
)

export default component.exports